import { handleException } from 'actions/exceptions';
import { ApiService } from 'services';

export const SEARCH_BATCHES_REQUEST = 'SEARCH_BATCHES_REQUEST';
export const SEARCH_BATCHES_SUCCESS = 'SEARCH_BATCHES_SUCCESS';
export const SEARCH_BATCHES_FAILURE = 'SEARCH_BATCHES_FAILURE';

function requestSearchBatches() {
  return {
    type: SEARCH_BATCHES_REQUEST,
    isGettingBatches: true
  };
}

function receiveSearchBatches(batches, batchesCount) {
  return {
    type: SEARCH_BATCHES_SUCCESS,
    isGettingBatches: false,
    batches,
    batchesCount
  };
}

function rejectSearchBatches() {
  return {
    type: SEARCH_BATCHES_FAILURE,
    isGettingBatches: false
  };
}

export function searchBatches(pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery) {
  return (dispatch) => {
    dispatch(requestSearchBatches());
    const promise = () => ApiService
      .searchBatches(pageNumber, pageSize, sortBy, sortDirection, filters, searchQuery)
      .then((response) => {
        dispatch(receiveSearchBatches(response.data.batches, response.data.totalCount));
      })
      .catch((error) => {
        if (!error.response && error.retries && error.retries > 1) {
          ApiService.addQueuedPromise(promise, error);
        }
        if (error.response || (error.retries && error.retries > 1)) {
          dispatch(handleException(error, rejectSearchBatches, true));
        }
      });
    return promise();
  };
}
